// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OKCn9","colBig":"styles_colBig__2SYYy","colSmall":"styles_colSmall__2fM6O","shopifyNameWrapper":"styles_shopifyNameWrapper__248fZ"};